import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "views/auth-context";

const ProtectedRoute = ({ component: Component, admin, user, ...rest }) => {
    const { isLoggedIn, role } = useContext(AuthContext);
  
    return (
      <Route
        {...rest}
        render={(props) => {
          if (admin && (!isLoggedIn || role !== "admin")) {
            return <Redirect to="/" />;
          }
  
          if (user && !isLoggedIn) {
            return <Redirect to="/login" />;
          }
  
          return <Component {...props} />;
        }}
      />
    );
  };

export default ProtectedRoute;